import React from "react";
import logo from "../images/logo.svg";
import { withRouter } from "../components/withRouter";
import { hostsSettings } from "../configs/app.config";
import { LogoSvg } from "../components/loading";
import ConfirmaitonModal from "../components/confirmation_modal";
import WebApp from "@twa-dev/sdk";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      error: "",
      isLoading: true,
      confirmation: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      error: "",
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { username, password } = this.state;

    if (!username || !password) {
      this.setState({ error: "Все поля обязательны для заполнения" });
      return;
    }

    this.setState({ isLoading: true });

    fetch(hostsSettings.apiPage + "/login", {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
      }),
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        chat: WebApp?.initData,
        login: this.state.username,
        password: this.state.password,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error && res.token) {
          localStorage.setItem("digitalkassir_idtn_cms_frm", res.token);
          this.props.navigate("/login-code");
        } else {
          this.setState({ confirmation: true, isLoading: false });
        }
      });
  }

  checkToken() {
    fetch(hostsSettings.apiPage + "/check/login", {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
      }),
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        chat: WebApp?.initData,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) {
          localStorage.setItem("digitalkassir_idtn_cms_frm", res.token);
          this.props.navigate("/login-code");
        } else {
          localStorage.removeItem("digitalkassir_idtn_cms_frm");
          sessionStorage.removeItem("digitalkassir_appCode");
          this.setState({ isLoading: false });
        }
      });
  }

  handleCloseConfirmationAction = () => {
    this.setState({ confirmation: false });
  };

  render() {
    const { username, password, error, isLoading } = this.state;

    return (
      <div>
        {isLoading ? (
          <div className="loading_logo">
            <LogoSvg />
          </div>
        ) : (
          ""
        )}
        <div className="login-form">
          <img src={logo} alt="logo" />
          {error && <div className="error-message">{error}</div>}
          <form onSubmit={this.handleSubmit}>
            <div style={{ marginTop: 10 }}>
              <div className="form-group">
                <label htmlFor="username">Логин:</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={username}
                  onChange={this.handleChange}
                  disabled={isLoading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Пароль:</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={this.handleChange}
                  disabled={isLoading}
                />
              </div>
            </div>
            <button type="submit" disabled={isLoading} className={"btn btn_tdk"}>
              <span>Войти</span>
            </button>
          </form>
        </div>
        {this.state.confirmation == true ? (
          <ConfirmaitonModal
            closeAction={this.handleCloseConfirmationAction}
            image="🤔"
            title="Ошибка"
            description="Не верный логин или пароль, перепроверьте и попробуйте снова"
            cancelText="Понятно"
          />
        ) : (
          ""
        )}
      </div>
    );
  }

  componentDidMount() {
    setTimeout(() => this.checkToken(), 0);
  }
}

export default withRouter(Login);
